

import Price from "../../../../common/components/ob1/Price.vue";
import {PropType} from "vue";
import {PrixDTO} from "../../../common/configurator/models/InsuranceCrossSellOptionWithUnknownDevice";
import {
    PriceDetailsCashbackType,
    PriceDetailsPopinDto
} from "../../../../common/components/custom/models/PriceDetailsPopinDto";

export default {
    name: "PriceDetailsContent",
    components: {
        Price,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        offerType: {
            type: String,
            required: true,
        },
        offerName: {
            type: String,
            required: true,
        },
        offerPrice: {
            type: Object as PropType<PrixDTO>,
            required: true,
        },
        priceDetails: {
            type: Object as PropType<PriceDetailsPopinDto>,
            required: true,
        },
    },
    computed: {
        modalId() {
            return `price-details-popin-${this.id}`;
        },
        tileFinalPrice() {
            return this.priceDetails ? this.priceDetails.finalPrice : this.offerPrice.price;
        },
        tileFinalPricePermanent() {
            return this.priceDetails && this.priceDetails.finalPricePermanent
                ? this.priceDetails.finalPricePermanent
                : this.offerPrice.initialPrice;
        },
        tileDuration() {
            if (this.priceDetails && this.priceDetails.finalPriceDuration) {
                return this.priceDetails.finalPriceDuration;
            }
            return this.offerPrice.duration;
        },
        showTileOdrPrice() {
            return Boolean(this.priceDetails && this.priceDetails.cashbacks.length > 0);
        },
        cashbackType(): PriceDetailsCashbackType | undefined {
            if (this.priceDetails) {
                if (this.priceDetails.cashbacks.some(
                    (cashback) => cashback.cashbackType === PriceDetailsCashbackType.CHEAT_CODE
                )) {
                    return PriceDetailsCashbackType.CHEAT_CODE;
                } else if (this.priceDetails.cashbacks.some(
                    (cashback) => cashback.cashbackType === PriceDetailsCashbackType.SAFER_PHONE
                )) {
                    return PriceDetailsCashbackType.SAFER_PHONE;
                } else if (this.priceDetails.cashbacks.some(
                    (cashback) => cashback.cashbackType === PriceDetailsCashbackType.OTHER
                )) {
                    return PriceDetailsCashbackType.OTHER;
                }
            }
            return undefined;
        },
        showTileEndOfPromotionPrice() {
            return Boolean(this.priceDetails
                && this.priceDetails.hasDifferentNonPermanentDurations
                && !this.priceDetails.finalPriceDuration);
        }
    },
};
